/** Etiqueta genérica de lugar (consultorio/cancha/salón) por tipo de servicio. */

export const DEFAULT_ROOM_LABEL = 'Consultorio';

export function roomLabelOf(typeOrLabel) {
  if (typeOrLabel == null) return DEFAULT_ROOM_LABEL;
  if (typeof typeOrLabel === 'string') {
    const s = typeOrLabel.trim();
    return s || DEFAULT_ROOM_LABEL;
  }
  const s = String(typeOrLabel.room_label || '').trim();
  return s || DEFAULT_ROOM_LABEL;
}

/** Ej. "Consultorio 2", "Cancha 1" */
export function formatRoomUnit(label, n) {
  const unit = roomLabelOf(label);
  const num = Number(n);
  if (!Number.isFinite(num) || num < 1) return unit;
  return `${unit} ${num}`;
}
